import { useEffect, useRef, useState } from "react";
import ChevronDownIcon from "../../icons/chevronDownIcon";
import ChangeLang from "../../components/header/changeLanguage";
import Button from "../../components/buttons/button";
import { useTranslation } from "react-i18next";

const ProfileNav = () => {
  const [isOpen, setIsOpen] = useState(false);
  const popoverRef = useRef(null);
  const triggerRef = useRef(null);
  const { t } = useTranslation();

  const togglePopover = () => {
    setIsOpen((prev) => !prev);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        popoverRef.current &&
        !popoverRef.current.contains(event.target) &&
        !triggerRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <section className="relative">
      {/* الزر اللي يفتح البوبوفر */}
      <button
        ref={triggerRef}
        onClick={togglePopover}
        className="flex items-center gap-4 p-4 bg-white cursor-pointer dark:border dark:border-gray-500 dark:bg-gray-800 dark:text-white rounded-2xl shadow-mainShadow dark:shadow-none"
      >
        <img
          className="object-cover rounded-full size-8"
          src="/assets/team1.jpg"
          alt="team1"
        />
        <span>mohamed ali</span>
        <ChevronDownIcon className="size-6" />
      </button>

      {/* محتوى البوبوفر */}
      <div
        ref={popoverRef}
        className={`${
          isOpen ? "block" : "hidden"
        } absolute right-0 z-50 w-full p-4 mt-2 space-y-5 bg-white dark:border dark:border-gray-500 dark:bg-gray-800 text-black dark:text-white shadow-mainShadow dark:shadow-lg rounded-2xl`}
      >
        <img
          className="object-cover mx-auto rounded-full size-40"
          src="/assets/team1.jpg"
          alt="team1"
        />
        <div>
          <ChangeLang menuClassName="w-full !rounded-lg" />
          <Button
            text={t("signOut")}
            className="border-mainRed my-2 bg-white dark:bg-transparent w-full !py-2 !text-mainRed border dark:border-mainRed"
          />
        </div>
      </div>
    </section>
  );
};

export default ProfileNav;
